import React, { Component } from "react";
import { PaymentService } from './Services/PaymentService';
import {PaymentStatus, TxnType} from './StorePage/StoreDeliverySchedule';
import TextField from '@material-ui/core/TextField';

import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';

const styles = theme =>({
    toggleContainer: {
        height: 56,
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: `${theme.spacing(1)}px 0`,
        background: theme.palette.background.default,
    },
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
  });

class CollectPayment extends Component {

    constructor(props) {
        super(props);
        let payment = {};
        let user = this.props.user;
        if(!this.props.transaction){
            payment.user_id = user.id;
            payment.invoice_date = user.delivery_date;
            payment.total_amount = Math.round(user.total_amount);
            payment.amount = parseFloat(this.props.amount);
            payment.invoice_no = user.invoice_no;
            payment.agent_id = this.props.agent_id;
            payment.txn_type = TxnType.CASH;
            payment.status = user.payment_status;
        } else {
            payment = this.props.transaction;
            payment.agent_id = this.props.agent_id;
            payment.txn_type = TxnType.CASH;
            payment.total_amount = Math.round(parseFloat(payment.amount));
            payment.amount = payment.total_amount;
        }

        this.state = {
            show: true,
            payment: payment,
            user : user,
            postUpdate: this.props.postUpdate
        }

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onCollectClick = this.onCollectClick.bind(this);
        this.handleChangeCollection = this.handleChangeCollection.bind(this);
      }

    handleChangeCollection(e) {
        e.preventDefault();
        let change = this.state.payment;
        change[e.target.name] = e.target.value;
        this.setState({payment: change});
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    onCollectClick(e){
        if(e)
            e.preventDefault();
        let payment = this.state.payment;
        if(payment.total_amount > 0 && payment.txn_type){
            this.props.showConfirmDialog(`Confirm Collection of payment for invoice no : ${payment.invoice_no}?`, undefined, () =>{
                this.handleClose();
                payment.status = PaymentStatus.COLLECTED;
                PaymentService.markCollected(payment)
                .then(() => {
                    this.props.closeConfirmDialog();
                    this.props.showSnackBar('Payment Updated successfully', 'success');
                    this.state.postUpdate();
                })
                .catch(error => {
                    this.props.showSnackBar('Something went wrong', 'error');
                    console.log(error);
                });
            });
        }
    }

    render() {
        return (
            <div>
            <DialogMUI
                    disableBackdropClick
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">Collect Payment</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <TextField
                                        id="invoice_no"
                                        label="Invoice No"
                                        placeholder="Invoice No"
                                        name="invoice_no"
                                        disabled
                                        defaultValue={this.state.payment.invoice_no}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth />
                                <TextField
                                        id="amount"
                                        label="Amount"
                                        placeholder="Amount"
                                        name="amount"
                                        defaultValue={Math.round(this.state.payment.amount)}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        onChange={this.handleChangeCollection}
                                        variant="outlined"
                                        fullWidth />
                                <div>
                                    <InputLabel htmlFor="txn_type" style={{marginRight: '10px'}}>
                                        Type
                                    </InputLabel>
                                    <Select
                                        value={this.state.payment.txn_type}
                                        onChange={this.handleChangeCollection}
                                        input={
                                        <OutlinedInput
                                            labelWidth={0}
                                            name="txn_type"
                                            id="txn_type"
                                        />
                                        }
                                    >
                                            <MenuItem value={TxnType.CASH}>{TxnType.CASH}</MenuItem>
                                            <MenuItem value={TxnType.CHEQUE}>{TxnType.CHEQUE}</MenuItem>
                                    </Select>
                                </div>

                                {
                                    this.state.payment.txn_type === TxnType.CHEQUE ? 
                                        <TextField
                                            id="no"
                                            label="Cheque No"
                                            placeholder="Cheque No"
                                            name="no"
                                            defaultValue={this.state.payment.no}
                                            className={this.props.classes.textField}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={this.handleChangeCollection}
                                            fullWidth />
                                    : <div style={{minHeight: '20px'}}></div>
                                }
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.onCollectClick} color="primary" autoFocus>
                                Collect
                            </Button>
                        </DialogActions>
                </DialogMUI>
            </div>
        );
    }
}

export default withStyles(styles)(CollectPayment);